import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import { formatDataCell } from '@/creditflowresearch/ui/components/deals/helpers';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => formatDataCell(tranche.guidance);

const GuidanceCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="GuidanceCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default GuidanceCell;
